// extracted by css-extract-rspack-plugin
export default {"verifiedOld":"verifiedOld-dr_7P3","verifiedBlue":"verifiedBlue-d5YbGM","verifiedGovernment":"verifiedGovernment-REEvEw"};